import React from 'react';
import { Divider, Grid, Typography } from '@mui/material';
import { useOutletContext } from 'react-router-dom';

const JobContainer = ({ job, index }) => {
    const [mobileView] = useOutletContext();
    const styledContainer = {
        position: 'relative',
        
    };
    const divider = {
        position: 'relative',
        top: '-100%',
    };
    const secondaryTitle = {
        variant: 'subtitle2',
        fontSize: '14px',
        color: 'text.secondary',
        textAlign: 'left',
    };
    const primaryTitle = {
        textAlign: 'left',
        fontSize: '14px',
        color:'#000',
        // fontWeight: 600,
    };
    return (
        <>
            <Grid item  sm={6} xs={12}>
                <div style={{ ...styledContainer } }>
                    <Grid container spacing={2}>
                        <Grid item sm={5} xs={12}>
                            <Typography sx={{ ...secondaryTitle }}>1. Job Position</Typography>
                        </Grid>
                        <Grid item sm={7} xs={12}>
                            <Typography {...primaryTitle}>{job?.job_position}</Typography>
                        </Grid>
                        <Grid item sm={5} xs={12}>
                            <Typography sx={{ ...secondaryTitle }}>2. Recruiter</Typography>
                        </Grid>
                        <Grid item sm={7} xs={12}>
                            <Typography {...primaryTitle}>{job?.recruiter}</Typography>
                        </Grid>
                        <Grid item sm={5} xs={12}>
                            <Typography sx={{ ...secondaryTitle }}>3. Current Status</Typography>
                        </Grid>
                        <Grid item sm={7} xs={12}>
                            <Typography {...primaryTitle}>{job?.current_status}</Typography>
                        </Grid>
                        <Grid item sm={5} xs={12}>
                            <Typography sx={{ ...secondaryTitle }}>4. Interview Date</Typography>
                        </Grid>
                        <Grid item sm={7} xs={12}>
                            <Typography {...primaryTitle}>{job?.interview_date}</Typography>
                        </Grid>
                    </Grid>
                    {/* <Grid container item xs={12}>
                        <Grid item sm={5} xs={12}>
                            <Typography sx={{ ...secondaryTitle }}>5.Interview Time</Typography>
                        </Grid>
                        <Grid item sm={7} xs={12}>
                            <Typography {...primaryTitle}>{job?.interview_time || 'unavailable'}</Typography>
                        </Grid>
                    </Grid> */}
                </div>
                {index % 2 === 0 && !mobileView && index > 0 ? (
                    <Divider style={{ ...divider }} orientation='vertical'></Divider>
                ) : (
                    ''
                )}
            </Grid>
        </>
    );
};

export default JobContainer;
